module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="candidate-profile work-history-container">\n    <section id="work-experience" class="work-experience">\n        <article class="job-description">\n            ' +
((__t = ( html )) == null ? '' : __t) +
'\n        </article>\n    </section>\n</div>\n<div class="gut-check__description">\n    <p>\n        Provide some background for your ' +
__e( skillName ) +
' experience\n        while working at ' +
__e( selectedJob.company ) +
':\n    </p>\n    <textarea name="description">' +
__e( description ) +
'</textarea>\n</div>\n<footer>\n    <button class="btn btn-secondary btn-large js-back">Go Back</button>\n    <button class="btn btn-primary btn-large js-next">Next</button>\n</footer>\n';

}
return __p
}